module.exports = __webpack_public_path__ + "img/check.70532cc9.svg";